export default __webpack_public_path__ + "72f71e3c12f74caa96cd790d01648698.png";